import { PASSENGER_SERVICES } from "./performerCatalog.js";

// REISOR_PHASE3A_PERFORMER_PAYLOAD_V2

export function performerPayload(form = {}) {
  const category =
    String(
      form.performerCategory || ""
    ).toUpperCase();

  const assetType = String(
    form.assetType ||
    (
      category === "CARGO"
        ? "TRUCK"
        : category === "SPECIAL"
          ? "SPECIAL_EQUIPMENT"
          : category === "TOW"
            ? "TOW_TRUCK"
            : "CAR"
    )
  ).toUpperCase();

  const bodyType =
    category === "CARGO"
      ? form.bodyType
      : category === "PASSENGER"
        ? "Пассажирский"
        : "Спецтехника";

  const bodyTypeOther =
    category === "CARGO"
      ? (
          form.bodyType === "Другое"
            ? String(form.bodyTypeOther || "").trim()
            : ""
        )
      : category === "SPECIAL"
        ? String(form.bodyTypeOther || "").trim()
        : category === "TOW"
          ? "Эвакуатор"
          : assetType;

  return {
    performerCategory: category,
    assetType,

    assetSubtype:
      category === "SPECIAL"
        ? String(form.bodyTypeOther || "").trim()
        : "",

    seats:
      category === "PASSENGER"
        ? Number(form.seats)
        : null,

    passengerServices:
      category === "PASSENGER" &&
      Array.isArray(form.passengerServices)
        ? Array.from(
            new Set(
              form.passengerServices
                .map((value) => String(value || "").toUpperCase())
                .filter((value) => PASSENGER_SERVICES.includes(value))
            )
          )
        : [],

    bodyType,
    bodyTypeOther,

    capacityTons:
      String(form.capacityTons ?? "").trim()
        ? Number(form.capacityTons)
        : null,

    volumeM3:
      String(form.volumeM3 ?? "").trim()
        ? Number(form.volumeM3)
        : null,
  };
}
